module.exports = __webpack_public_path__ + "static/media/1009864.dee1ff4b.jpg";